<template>
  <div>
    <div
      v-if="loading"
      class="text-center p-5"
    >
      Loading form...
    </div>
    <div
      v-else-if="loadError"
      class="text-center p-5 text-danger"
    >
      {{ loadError }}
    </div>
    <template v-else>
      <div>
        <div class="formWrapper  niche-wr fspAcknowledgement filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-NVC-F14 REV: 11
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>FUNERAL SERVICE PACKAGE DETAILS ACKNOWLEDGEMENT 富贵殡仪配套详情确认书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row class="ssfp-single-row fspAc-gap1">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-cck font-b-600">
                      NV LEGACY 富贵传承
                    </div>
                    <div class="ssfp-check-container">
                      <div class="pp-check-group">
                        <div
                          class="pp-check-single"
                          :class="{ active: formData.needType === 'AS-NEED' }"
                        >
                          As-Need: {{ formData.needType === 'AS-NEED' ? ('$' + numberFormat(formData.productPrice)) : '-' }} (Incl. {{ formData.gstPercentage || 9 }}% GST)
                        </div><div
                          class="pp-check-single"
                          :class="{ active: formData.needType !== 'AS-NEED' }"
                        >
                          Pre-Need: {{ formData.needType !== 'AS-NEED' ? ('$' + numberFormat(formData.productPrice)) : '-' }} (Incl. {{ formData.gstPercentage || 9 }}% GST)
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle2">
                    <p>5D4N Funeral Service at Void Deck or Parlour</p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="fspDetail-table floatCss">
                    <table class="package-table">
                      <colgroup>
                        <col class="col-no">
                        <col class="col-cn">
                        <col class="col-en">
                        <col class="col-qty">
                        <col class="col-unit">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>配套细节</th>
                          <th>Package Details</th>
                          <th class="col-center">
                            Qty
                          </th>
                          <th class="col-center">
                            Unit
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="td-no">
                            1
                          </td>
                          <td>遗体接领及接送</td>
                          <td>Transfer Service</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            2
                          </td>
                          <td>遗体护理 （防腐，洗，穿，化）</td>
                          <td>Embalming & Make-up Services</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            3
                          </td>
                          <td>入殓物品：檀香，檀香木，往生被，莲花被，梳洗用品，纸伞</td>
                          <td>Encoffin Items: Sandalwood, Maitreya Quilt, Lotus Quilt, Wash Basin, Paper Umbrella</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            4
                          </td>
                          <td>拜祭用品</td>
                          <td>Prayer Materials</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            5
                          </td>
                          <td>白色孝服</td>
                          <td>White T-Shirt </td>
                          <td class="td-center">
                            20
                          </td>
                          <td class="td-center">
                            件/Units
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            6
                          </td>
                          <td>火化八方寿木</td>
                          <td>8 Sided Half Glass Casket Half Glass (8SLHB/8SLHY/8SLHBL)</td>
                          <td class="td-center dash">
                            1
                          </td>
                          <td class="td-center dash">
                            副/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            7
                          </td>
                          <td>寿衣/西装/海清</td>
                          <td>Longevity Set / Suit / Shroud</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="td-no"
                            style="vertical-align:top; padding-top:5px;"
                          >
                            8
                          </td>
                          <td>
                            <span class="label-main-cn">棚布（组屋楼下)</span>
                            <span class="sub-cn"># 灵堂布置</span>
                            <span class="sub-cn"># 灯</span>
                            <span class="sub-cn"># 地毯</span>
                            <span class="sub-cn"># 灵堂布</span>
                            <span class="sub-cn"># 风扇</span>
                            <span class="sub-cn"># 冷风机</span>
                            <span class="sub-cn"># 方桌</span>
                            <span class="sub-cn"># 圆桌</span>
                            <span class="sub-cn"># 椅子</span>
                            <span class="sub-cn"># 桌椅布</span>
                          </td>
                          <td>
                            <span class="label-main-en">Tentage Set Up At Void Deck</span>
                            <span class="sub-en"># Casket & Altar Area Setup</span>
                            <span class="sub-en"># General Lighting</span>
                            <span class="sub-en"># Carpet</span>
                            <span class="sub-en"># Dual Tone Curtain</span>
                            <span class="sub-en"># Stand Fan</span>
                            <span class="sub-en"># Air Cooler</span>
                            <span class="sub-en"># Square Table</span>
                            <span class="sub-en"># Round Table</span>
                            <span class="sub-en"># Chair</span>
                            <span class="sub-en"># Round Table & Chair Cover</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer">5</span>
                            <span class="qty-block">3</span>
                            <span class="qty-block">15</span>
                            <span class="qty-block">10</span>
                            <span class="qty-block">100</span>
                            <span class="qty-block">10</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer">支/Units</span>
                            <span class="qty-block">架/Units</span>
                            <span class="qty-block">张/Units</span>
                            <span class="qty-block">张/Units</span>
                            <span class="qty-block">张/Units</span>
                            <span class="qty-block">套/Units</span>
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="td-no"
                            style="vertical-align:top; padding-top:5px;"
                          />
                          <td>
                            <span class="sublabel-cn">殡仪礼堂</span>
                            <span class="sub-cn"># 桌子，椅子</span>
                          </td>
                          <td>
                            <span class="label-main-en">Parlour Set Up</span>
                            <span class="sub-en"># Table & Chair</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">4 – 6</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-spacer dash">套/Sets</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            9
                          </td>
                          <td>灵堂背景布置</td>
                          <td>Casket Area Backdrop</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            10
                          </td>
                          <td>礼堂装饰</td>
                          <td>Fountain Setup in Casket Area</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            11
                          </td>
                          <td>灵堂桌布置</td>
                          <td>Altar Table Setup</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            12
                          </td>
                          <td>佛桌布置</td>
                          <td>Buddha Table Setup</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            13
                          </td>
                          <td>魂帛灯台</td>
                          <td>Pedestal Light Box</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="td-no"
                            style="vertical-align:top; padding-top:5px;"
                          >
                            14
                          </td>
                          <td>
                            <span class="label-main-cn">接待处</span>
                            <span class="sub-cn"># 帛金箱</span>
                            <span class="sub-cn"># 帛金簿</span>
                            <span class="sub-cn"># 文具盒</span>
                            <span class="sub-cn"># 电子路灯</span>
                          </td>
                          <td>
                            <span class="label-main-en">Reception Table Setup</span>
                            <span class="sub-en"># Condolence Money Box</span>
                            <span class="sub-en"># Memorial Book</span>
                            <span class="sub-en"># Stationery Set</span>
                            <span class="sub-en"># Electrical Lamp</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">1</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">个/Unit</span>
                            <span class="qty-block">个/Unit</span>
                            <span class="qty-block">套/Unit</span>
                            <span class="qty-block">个/Unit</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            15
                          </td>
                          <td>遗照放大及相框</td>
                          <td>Photo Enlargement &amp; Frame</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="td-no"
                            style="vertical-align:top; padding-top:5px;"
                          >
                            16
                          </td>
                          <td>
                            <span class="label-main-cn">装饰花</span>
                            <span class="sub-cn"># 棺围花</span>
                            <span class="sub-cn"># 轻奢花海 (视场地供应情况而定)</span>
                            <span class="sub-cn"># 蜡烛花饰</span>
                            <span class="sub-cn"># 供佛花</span>
                            <span class="sub-cn"># 接待处桌花</span>
                            <span class="sub-cn"># 客桌花</span>
                          </td>
                          <td>
                            <span class="label-main-en">Floral Arrangement</span>
                            <span class="sub-en"># Surround Casket</span>
                            <span class="sub-en"># Grand Altar Flower Display (Subject to space availability)</span>
                            <span class="sub-en"># Candle</span>
                            <span class="sub-en"># Flower Offerings</span>
                            <span class="sub-en"># Reception Table</span>
                            <span class="sub-en"># Guest Table</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">2</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">1</span>
                            <span class="qty-block">10</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">套/Set</span>
                            <span class="qty-block">套/Set</span>
                            <span class="qty-block">个/Units</span>
                            <span class="qty-block">个/Unit</span>
                            <span class="qty-block">个/Unit</span>
                            <span class="qty-block">个/Units</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            17
                          </td>
                          <td>讣告</td>
                          <td>Funeral Notice</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            18
                          </td>
                          <td>电子讣告</td>
                          <td>Online Obituary</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            19
                          </td>
                          <td>电视与照片剪辑</td>
                          <td>TV &amp; TV Montage</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            套/Set
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            20
                          </td>
                          <td>净水台 (治丧处)</td>
                          <td>Flower Water Station at Funeral Wake</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            21
                          </td>
                          <td>诵经：入殓(1)西方(1) 西方(3) 出殡(1)</td>
                          <td>Buddhist Prayer: Encoffin(1) Night(1) Final Night(3) Funeral Day(1)</td>
                          <td class="td-center dash">
                            -
                          </td>
                          <td class="td-center dash">
                            -
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            22
                          </td>
                          <td>佛前供果</td>
                          <td>Buddha Fruit Offerings </td>
                          <td class="td-center dash">
                            -
                          </td>
                          <td class="td-center dash">
                            -
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            23
                          </td>
                          <td>水果及素菜祭品</td>
                          <td>Fruit & Vegetarian Offerings</td>
                          <td class="td-center">
                            4
                          </td>
                          <td class="td-center">
                            套/Sets
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            24
                          </td>
                          <td>流动厕所</td>
                          <td>BMobile Toilet</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            25
                          </td>
                          <td>冰箱</td>
                          <td>Chiller</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            26
                          </td>
                          <td>念佛机</td>
                          <td>Buddhist Prayer Device</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            27
                          </td>
                          <td>寄灵盒</td>
                          <td>An-Ling Box</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="td-no"
                            style="vertical-align:top; padding-top:5px;"
                          >
                            28
                          </td>
                          <td>
                            <span class="label-main-cn">饮料与配件</span>
                            <span class="sub-cn"># 瓶装水</span>
                            <span class="sub-cn"># 包装甜水</span>
                            <span class="sub-cn"># 什锦坚果</span>
                            <span class="sub-cn"># 糖果</span>
                            <span class="sub-cn"># 其他配件</span>
                            <span class="sub-cn"># 高级咖啡机饮料</span>
                            <span class="sub-cn"># 热茶饮料</span>
                            <span class="sub-cn"># 自助餐</span>
                            <span class="sub-cn"># 2位服务员 （4小时）</span>
                            <span class="sub-cn"># 6尺纸屋（包含铁架和配件）[双虎头]</span>
                          </td>
                          <td>
                            <span class="label-main-en">Snacks & Accessories</span>
                            <span class="sub-en"># Bottled Water (Ctn of 24 Bottles)</span>
                            <span class="sub-en"># Packet Drinks (Ctn of 24 Packets)</span>
                            <span class="sub-en"># Assorted Nuts (Pkt of 40 Units)</span>
                            <span class="sub-en"># Assorted Candies</span>
                            <span class="sub-en"># Misc Accessories</span>
                            <span class="sub-en"># Premium Coffee Beverages</span>
                            <span class="sub-en"># Assorted Tea Beverages</span>
                            <span class="sub-en"># Buffet</span>
                            <span class="sub-en"># 2 Pax Service Staff (4 Hrs)</span>
                            <span class="sub-en"># 6ft Paper House Set with Burning Cage & Accessories [Twin Tiger Head]</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">10</span>
                            <span class="qty-block">10</span>
                            <span class="qty-block">13</span>
                            <span class="qty-block">10</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-block">200</span>
                            <span class="qty-block">100</span>
                            <span class="qty-block">60</span>
                            <span class="qty-block">4</span>
                            <span class="qty-block">1</span>
                          </td>
                          <td
                            class="td-center"
                            style="vertical-align:top;"
                          >
                            <span class="qty-spacer">&nbsp;</span>
                            <span class="qty-block">箱/Ctn</span>
                            <span class="qty-block">箱/Ctn</span>
                            <span class="qty-block">包/Pkts</span>
                            <span class="qty-block">包/Pkts</span>
                            <span class="qty-spacer dash">–</span>
                            <span class="qty-block">杯/Cups</span>
                            <span class="qty-block">杯/Cups</span>
                            <span class="qty-block">位/Pax</span>
                            <span class="qty-block">晚/Nights</span>
                            <span class="qty-spacer">套/Set</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper  niche-wr fspAcknowledgement filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-NVC-F14 REV: 11
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>FUNERAL SERVICE PACKAGE DETAILS ACKNOWLEDGEMENT 富贵殡仪配套详情确认书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-form-wrapper">
            <b-col cols="12">
              <b-row class="ssfp-single-row fspAc-gap1">
                <b-col cols="12">
                  <div class="ssfp-text-field-row floatCss">
                    <div class="ssfp-text-field-single ssfp-field-width-cck font-b-600">
                      NV LEGACY 富贵传承
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle2">
                    <p>5D4N Funeral Service at Void Deck or Parlour</p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-single-row">
                <b-col cols="12">
                  <div class="fspDetail-table floatCss">
                    <table class="package-table">
                      <colgroup>
                        <col class="col-no">
                        <col class="col-cn">
                        <col class="col-en">
                        <col class="col-qty">
                        <col class="col-unit">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>配套细节</th>
                          <th>Package Details</th>
                          <th class="col-center">
                            Qty
                          </th>
                          <th class="col-center">
                            Unit
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="td-no">
                            29
                          </td>
                          <td>专业人员及殡仪协调人员</td>
                          <td>Pall Bearer & Support Team</td>
                          <td class="td-center dash">
                            -
                          </td>
                          <td class="td-center dash">
                            -
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            30
                          </td>
                          <td>出殡协调人员</td>
                          <td>Funeral Day Service Team</td>
                          <td class="td-center dash">
                            -
                          </td>
                          <td class="td-center dash">
                            -
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            31
                          </td>
                          <td>音响系统（出殡）</td>
                          <td>Funeral Day PA System</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            32
                          </td>
                          <td>水果篮</td>
                          <td>Fruit Basket</td>
                          <td class="td-center">
                            1
                          </td>
                          <td class="td-center">
                            个/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            33
                          </td>
                          <td>橙（回礼）</td>
                          <td>Orange Souvenir</td>
                          <td class="td-center dash">
                            20
                          </td>
                          <td class="td-center dash">
                            包/Pkts
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            34
                          </td>
                          <td>回礼袋</td>
                          <td>Souvenir Bag</td>
                          <td class="td-center dash">
                            60
                          </td>
                          <td class="td-center dash">
                            个/Units
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            35
                          </td>
                          <td>高贵灵车（单程）</td>
                          <td>Premium Hearse (Single Trip)</td>
                          <td class="td-center dash">
                            1
                          </td>
                          <td class="td-center dash">
                            辆/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            36
                          </td>
                          <td>送殡冷气巴士（双程）</td>
                          <td>44 Seater Bus (2 Way)</td>
                          <td class="td-center dash">
                            1
                          </td>
                          <td class="td-center dash">
                            辆/Unit
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            37
                          </td>
                          <td>万礼火化服务</td>
                          <td>Cremation at Mandai</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            38
                          </td>
                          <td>净水台</td>
                          <td>Flower Water Station at Crematorium</td>
                          <td class="td-center dash">
                            –
                          </td>
                          <td class="td-center dash">
                            –
                          </td>
                        </tr>
                        <tr>
                          <td class="td-no">
                            39
                          </td>
                          <td>照片存储设备</td>
                          <td>Photo Storage Device</td>
                          <td class="td-center dash">
                            1
                          </td>
                          <td class="td-center dash">
                            个/Unit
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="pp-section-tittle8">
                    <h4>Acknowledgement</h4>
                    <p>I agree to purchase Funeral Service Package at the purchase price and items specified herein upon the terms and subject to the above mentioned notes and conditions overleaf.</p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ssfp-signature ssfp-fsp-gp">
                <b-col cols="12">
                  <div class="pp-signature-area floatCss">
                    <p>Purchaser 购买者签名</p>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-row>
                    <b-col
                      cols="6"
                      md="6"
                      lg="6"
                    >
                      <div
                        v-if="formData.ackSignOne"
                        class="pp-signature-block floatCss"
                      >
                        <img
                          :src="formData.ackSignOne"
                          alt="signature"
                        >
                      </div>
                      <div
                        v-else
                        id="ackSignOne"
                        class="pp-signature-block signature-block-yellow floatCss"
                      >
                        <span>Sign here</span>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <div class="pp-signature-area floatCss">
                    <h4>Name 姓名: {{ formData.customerName }}</h4>
                    <h4>Date 日期: {{ (formData.ackSignOneDate ? dateFormatWithTime(formData.ackSignOneDate) : '') }}</h4>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <div class="page-break-after"></div>
        <div class="formWrapper filled">
          <b-row>
            <b-col cols="12">
              <div class="form-header floatCss">
                <b-row>
                  <b-col cols="12">
                    <div class="form-header-inner d-flex justify-content-between">
                      <div class="d-flex">
                        <div class="dForm-top-logo">
                          <img :src="logoSrc">
                        </div>
                        <div class="dForm-companyDetails">
                          <div class="dForm-cmBlock">
                            <h2>
                              <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                            </h2>
                          </div>
                          <div class="dForm-cmBlock2">
                            <p>(Co. Reg. No. 200401183W)</p>
                            <p>(GST Group Reg. No. M90364395L)</p>
                          </div>
                        </div>
                      </div>
                      <div class="dForm-top-right d-flex">
                        <h5 class="text-block font-small-12">
                          NV-SG-NVC-F14 REV: 11
                        </h5>
                        <h5>File No: {{ formData.fileNo || '-' }}</h5>
                        <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="pp-section-tittle">
                      <h2>FUNERAL SERVICE PACKAGE DETAILS ACKNOWLEDGEMENT 富贵殡仪配套详情确认书</h2>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="pp-section-tittle2">
                <h2>TERMS & CONDITIONS</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-top-20"
            >
              <div class="tc-single-wrapper floatCss">
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    1
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Applicable for cremation package only.</p>
                      <p>只限于火化配套。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    2
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The choice of parlour to be used shall be made at the Company's discretion from the list of the Company's approved parlour venues. Use of any other parlour shall be subject to additional charges.</p>
                      <p>只允许使用公司特定殡仪厅，若使用其他殡仪厅则需额外付费。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    3
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Use of parlour is subject to availability.</p>
                      <p>追思礼堂使用胥视其届时供应的情况而定。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    4
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Taoist prayer service is subject to additional charges.</p>
                      <p>道教仪式所需用品需另额外收费。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    5
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Niche, Urn and Pedestal are excluded from this package.</p>
                      <p>此配套不包括骨灰福位，骨灰瓮及神主牌位。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    6
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The FSP shall be exercised strictly in the Republic of Singapore.</p>
                      <p>此生前契约配套仅限于新加坡国内启用。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    7
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The Purchaser shall only be permitted to exercise and utilize the Package after thirty (30) days from the date of purchase. Any utilization of the Package within thirty (30) days from date of purchase shall be treated as an As-Need case and As-Need prices will apply.</p>
                      <p>客户只能在购买配套之日起的三十（30）天后启用该契约。 自购买配套之日起的三十（30）天内启用该契约，此契约将会被视作即用配套而客户需依据即用配套的价格付费。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    8
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The Company shall not be liable for any direct, indirect or consequential losses in the event that the specific hearse or vehicle is not available as a result of circumstances beyond it's control provided that an alternative mode of conveyance or transport is made available.</p>
                      <p>任何由于某些无可预测的缘故或是发生任何超出公司所能控制的情况，致使指定的灵车或交通工具无法被使用，公司有权以其他运输或交通方式代替，而无需承担任何责任。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    9
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Unused items regarded as forfeited. No refund or return of the items in the package shall be allowed under any whatsoever circumstances.</p>
                      <p>无论在任何情况下，没使用的项目视同放弃，所有列在契约的项目物品皆不能退还或退款。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    10
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Upgrading of items is allowed based on availability of the items.</p>
                      <p>在可行的情况下，公司允许提升契约（配套）内的项目。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    11
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Additional nights or additional items are subject to additional charges.</p>
                      <p>若需使用配套以外的奠礼服务或额外的物品，公司将附加收费。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    12
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>Additional charges are applicable if the casket required exceeds the standard size of H (Height) 48.26cm, W (Width) 61.98cm, L (Length) 194.06cm.</p>
                      <p>若超过配套的棺木标准尺寸，H (高) 48.26cm, W (宽) 61.98cm, L (长) 194.06cm, 将需额外收费。</p>
                    </div>
                  </div>
                </div>
                <div class="tc-single-block-pp floatCss">
                  <div class="tc-single-number">
                    13
                  </div>
                  <div class="tc-info-rt">
                    <div class="floatCss">
                      <p>The terms and conditions in English language shall prevail over Chinese language, should any conflict arise in the interpretation of the terms and conditions herein.</p>
                      <p>如对上述规则与条件的中文译本，产生任何诠译上的争议，将以英语译本为诠译的标准。</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-signature">
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <p>Purchaser 购买者签名</p>
              </div>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                  lg="6"
                >
                  <div
                    v-if="formData.ackSignTwo"
                    class="pp-signature-block floatCss"
                  >
                    <img
                      :src="formData.ackSignTwo"
                      alt="signature"
                    >
                  </div>
                  <div
                    v-else
                    id="ackSignTwo"
                    class="pp-signature-block signature-block-yellow floatCss"
                  >
                    <span>Sign here</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <div class="pp-signature-area floatCss">
                <h4>Name 姓名: {{ formData.customerName }}</h4>
                <h4>Date 日期: {{ (formData.ackSignTwoDate ? dateFormatWithTime(formData.ackSignTwoDate) : '') }}</h4>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: {},
      loading: true,
      loadError: null,
    }
  },

  created() {
    this.loadFormData()
  },

  methods: {
    // App opens this page in a webview with the saved form's id (route param) - fetches the
    // data the app earlier saved via POST /sales/form/fsp/acknowledgement/legacy/data instead of reading injected
    // localStorage, which is what the Puppeteer-rendered source form still does.
    //
    // This hits the front-end/ router (optionalAuth, no token required - the id itself is the
    // access control), not reservation-app/ - so this.$http is safe to use here: no 401 is
    // possible, meaning its global interceptor's hard-redirect-to-/login (src/libs/axios.js)
    // never triggers.
    loadFormData() {
      const { id } = this.$route.params
      this.$http.get(`front-end/sales/form/fsp/acknowledgement/legacy/data/${id}`)
        .then(response => {
          this.formData = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loadError = (error.response && error.response.data && error.response.data.message) || 'Unable to load form data.'
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
  },
}
</script>

<style>
@media print {
  .page-break-after {
    display: block;
    /* ensure block context */
    page-break-before: always;
    /* legacy */
    break-before: page;
  }

  .formWrapper,
  .niche-wr,
  .ssfp-form-wrapper,
  .ssfp-signature {
    page-break-inside: avoid;
    /* legacy */
    break-inside: avoid;
    /* modern */
  }
}
.formWrapper .ssfp-signature .pp-signature-block {
  line-height: 40px !important;
  height: 40px !important;
}
.formWrapper.fspAcknowledgement .form-header {
  padding-bottom: 5px !important;
}
.form-header .form-header-inner {
  padding-bottom: 10px !important;
}
</style>
